// List formatting + clipboard utilities
// Ported from public/selected-cards.js formatSimpleList/formatMarkdownList/copyTextToClipboard

import { getCurrencySymbol } from './utils.js';

/**
 * Format a plain-text card list sorted by price.
 *
 * @param {Array} cards - Selected cards array (sorted)
 * @param {string} selectedCurrency - 'usd' or 'eur'
 * @returns {string} Formatted text
 */
export function formatSimpleList(cards, selectedCurrency) {
  let total = 0;
  const sym = getCurrencySymbol(selectedCurrency);

  const lines = cards.map((c) => {
    total += c.price * c.selectedCount;
    const langPart = c.lang && c.lang.toLowerCase() !== 'en' ? ` [${c.lang.toUpperCase()}]` : '';
    const namePart = `${c.selectedCount > 1 ? c.selectedCount + 'x ' : ''}${c.name} (${c.set ? c.set.toUpperCase() : 'N/A'})${langPart}${c.isFoil ? ' ★' : ''}`;
    const pricePart = `${sym}${(c.price * c.selectedCount).toFixed(2)}`;
    return `${namePart} - ${pricePart}`;
  });

  lines.push('', `Total: ${sym}${total.toFixed(2)}`);
  return lines.join('\n');
}

/**
 * Copy text to clipboard using Clipboard API with textarea fallback.
 *
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} True if copy succeeded
 */
export async function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error('[Copy] Clipboard API write failed:', err);
    }
  }

  // Fallback: hidden textarea + execCommand
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    return success;
  } catch (err) {
    console.error('[Copy] Fallback copy method failed:', err);
    return false;
  }
}
